import type { FC } from "react";
import { tv } from "tailwind-variants";
import { Size } from "../helpers/helpers.js";

export interface PillDashProps {
  size: Size;
}

// Heights mirror `pillStyle`, so that a column mixing values, dashes and
// skeletons keeps one row height throughout loading.
const pillDash = tv({
  base: "inline-flex items-center text-muted-foreground",
  variants: {
    size: {
      [Size.SMALL]: "h-6",
      [Size.MEDIUM]: "h-9",
      [Size.LARGE]: "h-11",
    },
  },
});

/** The muted `--` shown in place of a pill whose value is absent. */
export const PillDash: FC<PillDashProps> = (props) => (
  <span className={pillDash({ size: props.size })}>--</span>
);
